import { render, staticRenderFns } from "./NewClass.vue?vue&type=template&id=0a0ff397&scoped=true&"
import script from "./NewClass.vue?vue&type=script&lang=js&"
export * from "./NewClass.vue?vue&type=script&lang=js&"
import style0 from "./NewClass.vue?vue&type=style&index=0&id=0a0ff397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ff397",
  null
  
)

export default component.exports